<ng-container *ngIf="variant === 'horizontal-style-1'">
    <navbar-horizontal-style-1></navbar-horizontal-style-1>
</ng-container>

<ng-container *ngIf="variant === 'vertical-style-1'">
    <navbar-vertical-style-1></navbar-vertical-style-1>
</ng-container>

<ng-container *ngIf="variant === 'vertical-style-2'">
    <navbar-vertical-style-2 id="navbar-vertical-2"></navbar-vertical-style-2>
</ng-container>

<ng-container *ngIf="variant === 'pretty-easy'">
<!--    <navbar-vertical-style-2></navbar-vertical-style-2>-->
    <app-pretty-easy-navigation role="complementary"></app-pretty-easy-navigation>
</ng-container>
